module.exports = __webpack_public_path__ + "static/media/gif.1a0b9f09.gif";